<template>
  <div>
    <search-block-main></search-block-main>
    <div class="belt">
      <div class="belt__container" v-if="searchResultsList.length != 0">
        <div class="belt__boxes">
          <div class="belt__box belt__box--left">
            <items-per-page></items-per-page>
            <sort-dropdown></sort-dropdown>
          </div>
          <div class="belt__box belt__box--right">
            <pagination-with-input></pagination-with-input>
          </div>
        </div>
      </div>
    </div>
    <div class="search__container">
      <div class="search__boxes">
        <div class="search__box search__box--left">
          <div class="block block--info">
            <div class="block__title"><h3 class="block__title--text">{{ $lang.search.info.title }}</h3></div>
            <div class="block__content">
              <search-info></search-info>
            </div>
          </div>
          <div class="block block--filters">
            <div class="block__title"><h3 class="block__title--text">{{ $lang.filters.title }}</h3></div>
            <div class="block__content">
              <search-filters></search-filters>
            </div>
          </div>
        </div>
        <div class="search__box search__box--right">
          <div class="block block--results">
            <div class="block__title"><h3 class="block__title--text">{{ $lang.search.results.title }}</h3></div>
            <div class="block__content">
              <search-results></search-results>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters} from 'vuex'

import SearchBlockMain from './../Search/SearchBlockMain'
import SearchResults from './../Search/SearchResults'
import SearchInfo from './../Search/SearchInfo'
import SearchFilters from './../Search/SearchFilters'

import Pagination from './../Global/Pagination'
import PaginationWithInput from './../Global/PaginationWithInput'
import ItemsPerPage from './../Global/ItemsPerPage'
import SortDropdown from './../Global/SortDropdown'

export default {
  name: 'search',
  components: {
    'search-block-main': SearchBlockMain,
    'search-results': SearchResults,
    'search-info': SearchInfo,
    'search-filters': SearchFilters,

    'pagination': Pagination,
    'pagination-with-input': PaginationWithInput,
    'sort-dropdown': SortDropdown,
    'items-per-page': ItemsPerPage
  },
  computed: {
          ...mapGetters({
            searchResultsList: 'GET_SEARCH_RESULTS_DOCS',
            fixed: 'GET_APP_SCROLL'
          }),

  }
}
</script>



// WEBPACK FOOTER //
// Search.vue?48c81364